import { useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { register } from "@teamhanko/hanko-elements";

const hankoApi = process.env.BUN_PUBLIC_HANKO_API_URL as string;

export function HankoSignup() {
  const navigate = useNavigate();

  const redirectAfterSignup = useCallback(() => {
    navigate("/dashboard");
  }, [navigate]);

  useEffect(() => {
    register(hankoApi).catch((error) => {
      console.error("Failed to register Hanko elements:", error);
    });
  }, []);

  useEffect(() => {
    const handleSessionCreated = () => {
      redirectAfterSignup();
    };

    document.addEventListener("hankoAuthSuccess", handleSessionCreated);

    return () => {
      document.removeEventListener("hankoAuthSuccess", handleSessionCreated);
    };
  }, [redirectAfterSignup]);

  return <hanko-registration />;
}
